import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

// Served straight from the public/ folder (not a bundled module import) —
// CRA copies public/ as-is to the build root, so this resolves at runtime
// regardless of the app's deploy path.
const unauthorizedIllustration = `${process.env.PUBLIC_URL}/Unauthorized.png`;

const ACCENT = "#86BC25";
const ACCENT_HOVER = "#749f1f";

// Shared "you can't be here" screen for every route guard (RequireOrgRole,
// RequireOrgOwnerRole, RequireEcrOpsRole, RequireAccessManagementRole,
// RequireLeadershipRole, RequirePermission) — previously six copies of the
// same plain heading + one-line message + single button, duplicated with
// tiny per-guard variations in wording and destination. Centralized here so
// a future visual change (or copy tweak) happens once.
const UnauthorizedAccess = ({
  message,
  primaryLabel = "Back to home dashboard",
  primaryTo = "/dashboard",
  secondaryLabel,
  secondaryTo,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        py: 6,
      }}
    >
      <Box sx={{ maxWidth: 720, textAlign: "center" }}>
        <Box
          component="img"
          src={unauthorizedIllustration}
          alt=""
          sx={{
            width: "100%",
            maxWidth: 620,
            height: "auto",
            display: "block",
            mx: "auto",
            mb: 3,
          }}
        />

        <Typography
          sx={{
            fontSize: { xs: "1.9rem", md: "2.3rem" },
            fontWeight: 800,
            lineHeight: 1.15,
            color: "#14231F",
            mb: 1.5,
          }}
        >
          We are sorry&hellip;
        </Typography>

        <Typography
          sx={{
            fontSize: "1rem",
            color: "#4A5B57",
            maxWidth: 460,
            mx: "auto",
            mb: 4,
          }}
        >
          {message}
        </Typography>

        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center", flexWrap: "wrap" }}>
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: ACCENT,
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "999px",
              px: 4,
              "&:hover": { backgroundColor: ACCENT_HOVER },
            }}
            onClick={() => navigate(primaryTo)}
          >
            {primaryLabel}
          </Button>
          {secondaryLabel && (
            <Button
              variant="outlined"
              size="large"
              sx={{
                color: ACCENT,
                borderColor: "#C6E4A0",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "999px",
                px: 4,
                "&:hover": { borderColor: ACCENT, backgroundColor: "#F3F9EC" },
              }}
              onClick={() => navigate(secondaryTo)}
            >
              {secondaryLabel}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default UnauthorizedAccess;
